<template>
    <v-container class="pa-4 text-center">
        <template>
            <p class="display-1 font-weight-light">Daftar Barang</p>
            <p class="pl-8 body-2 text-left font-weight-bold mt-5">Pilih kategori barang: </p>
            <v-layout row wrap>
                <template v-for="(item, i) in item_categories">
                    <v-flex xs3 class="my-4" :key="i">
                        <template>
                            <v-card
                                class="mx-auto"
                                color="green lighten-5"
                                max-width="200"
                                height="100%"
                                style="cursor: pointer"
                                @click="onSelectProductCategory(item)"
                            >
                                <v-img
                                    :aspect-ratio="16/9"
                                    src="https://cdn.vuetifyjs.com/images/cards/kitchen.png"
                                    class="white--text align-end"
                                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                                    height="50px"
                                    >
                                    <v-card-text class="text-left" v-text="item.name+' ('+item.total_products+')'"></v-card-text>
                                </v-img>
                                <!-- <v-card-text
                                    class="pt-6 text-left"
                                    style="position: relative; height:auto"
                                > -->
                                    <!-- <v-img
                                        :aspect-ratio="16/9"
                                        src="https://cdn.vuetifyjs.com/images/cards/kitchen.png"
                                        rounded
                                    >
                                    </v-img> -->
                                    <!-- <v-list-item-avatar
                                        tile
                                        size="80"
                                        color="grey"
                                    ></v-list-item-avatar>
                                    <span class="font-weight-light subtitle-2 black--text">{{item.name}}</span><br />
                                    <span class="font-weight-medium caption black--text">Jumlah Barang: {{item.total_products}}</span><br />
                                </v-card-text> -->
                            </v-card>
                        </template>
                    </v-flex>
                </template>
            </v-layout>
        </template>
        <template v-if="isShowProduct">
            <!-- <p class="display-1 font-weight-light mt-5">Daftar Barang</p> -->
            <p class="pl-8 body-2 text-left font-weight-light mt-5">Menampilkan {{selectedCategory.total_products}} barang dari kategori {{selectedCategory.name}}</p>
            <v-layout row wrap>
                <template v-for="(item, i) in listProduct">
                    <v-flex xs3 class="my-4" :key="i">
                        <template>
                            <v-hover v-slot:default="{ hover }">
                                <v-card
                                    class="mx-auto"
                                    color="green lighten-5"
                                    max-width="200"
                                    height="100%"
                                >
                                    <v-img
                                        :aspect-ratio="16/9"
                                        v-bind:src="item.attachment"
                                    >
                                    <v-expand-transition>
                                        <div
                                            v-if="hover"
                                            :class="(Number(item.stock) <= 0) ? 'red darken-2 d-flex transition-fast-in-fast-out v-card--reveal white--text' : 'green darken-2 d-flex transition-fast-in-fast-out v-card--reveal white--text'"
                                            style="height: 100%;"
                                        >
                                            <span v-if="(Number(item.stock) <= 0)">Out of Stock</span>
                                            <span v-else>Available</span>
                                        </div>
                                    </v-expand-transition>
                                    </v-img>
                                    <v-card-text
                                        class="pt-6 text-left"
                                        style="position: relative; height:auto"
                                    >
                                        <v-btn
                                            absolute
                                            color="green darken-1"
                                            :disabled="Number(item.stock) <= 0"
                                            class="white--text"
                                            x-small
                                            fab
                                            right
                                            top
                                            @click="addToCart(item)"
                                        >
                                            <v-icon>add</v-icon>
                                        </v-btn>
                                        <span class="font-weight-light subtitle-2 black--text">{{item.name}}</span><br />
                                        <span class="font-weight-medium caption black--text">Stok: {{item.stock}}</span><br />
                                        <span class="font-weight-medium caption black--text">Harga: Rp. {{item.harga_jual}}</span>
                                    </v-card-text>
                                </v-card>
                            </v-hover>
                        </template>
                    </v-flex>
                </template>
            </v-layout>
        </template>
    </v-container>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { forEach, findIndex } from "lodash";
export default {
    name: "DaftarBarang",
    data: () => ({
        item_products: [],
        item_categories: [],
        isShowProduct: false,
        selectedCategory: null
    }),
    computed: {
        ...mapState({
            listPesanan: state => state.products.listPesanan,
            listProduct: state => state.products.listProduct
        }),
    },
    async created(){
        this.showLoading({ color: 'white' })
        // const response = await this.dataProducts()
        const responseCategory = await this.getProductCategory(['MANAGED_STOCK'])

        if(responseCategory.data.status){
            forEach(responseCategory.data.attributes, data => {
                this.item_categories.push(data)
            })
        }else{
            this.showSnackbar({ text: responseCategory.data.message, color: 'red', timeout: 1500 })
        }

        // if(response.data.success){
        //     forEach(response.data.attributes, data => {
        //         data.harga_jual = Number(data.harga_jual)
        //         data.harga_beli = Number(data.harga_beli)
        //         this.item_products.push(data)
        //     })
        //     this.setListProduct(this.item_products)
            
        // }else{
        //     this.showSnackbar({ text: response.data.message, color: 'red', timeout: 1500 })
        // }
        this.closeLoading()
    },
    methods: {
        ...mapMutations({
            showSnackbar: "showSnackbar",
            showLoading: "showLoading",
            closeLoading: "closeLoading",
            setListPesanan : "products/SET_LIST_PESANAN",
            setListProduct : "products/SET_LIST_PRODUCT",
            setDialogOrder: "pesanan/SET_DIALOG_ORDER"
        }),
        ...mapActions({
            calculateTotal: "products/calculateTotal",
            dataProducts: "products/getProducts",
            getProductCategory: "products/getProductCategory"
        }),
        addToCart(item) {
            let currentPesanan = this.listPesanan
            // console.log(currentPesanan)
            // console.log(item)

            // return console.log(find(currentPesanan, ['item_id', item.id]))

            const findPesanan = findIndex(currentPesanan, ['product_id', item.id])

            if(findPesanan > -1){
                // return console.log(currentPesanan[findPesanan])
                currentPesanan[findPesanan].qty = Number(currentPesanan[findPesanan].qty) + 1
            }else{
                const itemPesanan = {
                    product_id: item.id,
                    item_name: item.name,
                    harga_jual: item.harga_jual,
                    qty: 1,
                    discount: 0,
                    ppn: 0,
                    stock: item.stock
                }
    
                currentPesanan.push(itemPesanan)
            }

            this.setListPesanan(currentPesanan)
            this.calculateTotal()
            // console.log('item', item)
            // console.log('listPesanan', this.listPesanan)
        },
        async onSelectProductCategory(category){
            this.selectedCategory = category
            this.item_products = []
            this.showLoading({ color: 'white' })
            const response = await this.dataProducts(category.id)

            if(response.data.success){
                forEach(response.data.attributes, data => {
                    data.harga_jual = Number(data.harga_jual)
                    data.harga_beli = Number(data.harga_beli)
                    if(data.product_attachment && data.product_attachment.length > 0){
                      data.attachment = process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL + '/' + data.product_attachment[0].location + '/' + data.product_attachment[0].name
                    }
                    this.item_products.push(data)
                })
                this.setListProduct(this.item_products)
                this.isShowProduct = true
            }else{
                this.showSnackbar({ text: response.data.message, color: 'red', timeout: 1500 })
            }
            this.closeLoading()
        }
    },
};
</script>
<style scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .5;
  position: absolute;
  width: 100%;
}
</style>
